/* eslint-disable */
var React = require('react');
var SpriteSymbol = require("../../../svg-baker-runtime/browser-symbol.js");
var sprite = require("../../../svg-sprite-loader/runtime/browser-sprite.build.js");

var symbol = new SpriteSymbol({
  "id": "credit-card-back-d43575a1--sprite",
  "use": "credit-card-back-d43575a1--sprite-usage",
  "viewBox": "0 0 36 36",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 36 36\" id=\"credit-card-back-d43575a1--sprite\"><g transform=\"translate(36 36) rotate(180)\"><g transform=\"translate(36 36) rotate(180)\" opacity=\"0\"><g fill=\"#fff\" stroke=\"#707070\" stroke-width=\"1\" opacity=\"0.5\"><rect width=\"36\" height=\"36\" stroke=\"none\" /><rect x=\"0.5\" y=\"0.5\" width=\"35\" height=\"35\" fill=\"none\" /></g></g></g><g transform=\"translate(9.114 12.074)\"><path d=\"M-277.532,27.82v1.17h-17.779V27.82a.987.987,0,0,1,.99-.99h15.8A.993.993,0,0,1-277.532,27.82Z\" transform=\"translate(295.311 -26.83)\" fill=\"currentColor\" /><path d=\"M-295.311,36.44v6.538a.987.987,0,0,0,.99.99h15.8a.993.993,0,0,0,.99-.99V36.44Zm3.793,5.922h-1.116a1.08,1.08,0,0,1-1.08-1.08,1.06,1.06,0,0,1,.319-.76,1.06,1.06,0,0,1,.76-.319h1.116a1.08,1.08,0,0,1,1.08,1.08A1.077,1.077,0,0,1-291.518,42.362Z\" transform=\"translate(295.311 -32.116)\" fill=\"currentColor\" /></g></symbol>"
});
sprite.add(symbol);

var SvgSpriteIcon = function SvgSpriteIcon(props) {
  return React.createElement(
    'svg',
    Object.assign({
      viewBox: symbol.viewBox
    }, props),
    React.createElement(
      'use',
      {
        xlinkHref: '#' + symbol.id
      }
    )
  );
};

SvgSpriteIcon.viewBox = symbol.viewBox;
SvgSpriteIcon.id = symbol.id;
SvgSpriteIcon.content = symbol.content;
SvgSpriteIcon.url = symbol.url;
SvgSpriteIcon.toString = symbol.toString;

module.exports = SvgSpriteIcon;
module.exports.default = SvgSpriteIcon;
